module.exports = __webpack_public_path__ + "img/article4-1.b6a8ad28.jpg";